<template>
  <div class="min-w-screen relative z-0 flex min-h-screen w-full items-center">
    <CookieBanner
      v-if="showCookieBanner"
      class="z-50 transition-opacity"
      @show-cookie-banner="showCookieBanner = $event"
    />

    <Toaster />

    <Suspense>
      <RouterView class="z-0" />
    </Suspense>
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';

  import CookieBanner from '@/components/base/cookieBanner.component.vue';
  import Toaster from '@/components/ui/toast/Toaster.vue';

  const showCookieBanner = ref(true);

  const getCookie = (cookieName: string): string => {
    const cookies = document.cookie.split('; ').filter(Boolean);

    for (const cookie of cookies) {
      const eqIdx = cookie.indexOf('=');
      const currentName = eqIdx >= 0 ? cookie.slice(0, eqIdx) : cookie;
      const currentValue = eqIdx >= 0 ? cookie.slice(eqIdx + 1) : '';

      if (currentName === cookieName) {
        return currentValue;
      }
    }

    return '';
  };

  const syncCookieConsentBanner = () => {
    const showCookiePreferencesBanner = getCookie('bextPro_showCookieBanner');

    if (!showCookiePreferencesBanner.length) {
      showCookieBanner.value = true;
      return;
    }

    showCookieBanner.value = showCookiePreferencesBanner !== 'false';
  };

  onMounted(() => {
    syncCookieConsentBanner();
    document.getElementById('app')?.classList.add('loaded');
  });
</script>
